<template>
    <main>

         <UserAccount />

    </main>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";


    export default {
      components: {
           UserAccount: () => import('./User/Index.vue')
        },
        data () {
            return {

            }
        },
        watch:{

        },
        methods: {
          ...mapActions('Common',['updateNewLayout'])

        },
        async mounted() {
            this.updateNewLayout("No")

        },
        async created() {

        },
        filters: {

        },
        computed: {
            ...mapGetters("auth", ["user"]),
            ...mapGetters(["errors"]),
        },

    }
</script>
